export const propMiscModals = {
  policia: {
    title: "Détails d'enregistrement",
    heading: "Enregistrez les informations des autorités compétentes",
    subtitle:
      "Synchronisez automatiquement les check-ins de votre propriété avec les autorités",
    entityLabel: "Nom de l'entité",
    entityPlaceholder: "Sélectionnez une entité",
    userLabel: "Nom d'utilisateur",
    passwordLabel: "Mot de passe",
    accessError:
      "Vérifiez vos identifiants d'accès ; nous vous recommandons de ne pas essayer plus de trois fois, sous peine de bloquer votre compte.",
    validateBtn: "Valider",
    saveBtn: "Enregistrer les informations",
    entityRequired: "L'entité est requise",
    usernameRequired: "Le nom d'utilisateur est requis",
    passwordRequired: "Vous devez saisir le mot de passe",
    validateError: "Erreur lors de la validation des informations",
    saveError: "Erreur lors de l'enregistrement des informations de la police des étrangers",
  },
  upgrade: {
    heading: "Améliorez votre forfait pour continuer à créer des propriétés",
    message:
      "Bonjour ! Nous avons remarqué que vous avez atteint la limite de propriétés autorisées par votre forfait actuel.",
    button: "Améliorer le forfait",
  },
};
